var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollaborate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #596e85;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        opacity: .7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200,
    cy: 200,
    r: 197.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,296.54c-53.23,0-96.54-43.31-96.54-96.54s43.31-96.54,96.54-96.54,96.54,43.31,96.54,96.54-43.31,96.54-96.54,96.54ZM200,114.84c-46.95,0-85.15,38.2-85.15,85.16s38.2,85.15,85.15,85.15,85.16-38.2,85.16-85.15-38.2-85.16-85.16-85.16Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200,
    cy: 109.15,
    r: 31.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200,
    cy: 290.85,
    r: 31.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 106.57,
    cy: 200,
    r: 31.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 290.85,
    cy: 200,
    r: 31.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollaborate);
export default __webpack_public_path__ + "static/media/Icon-Collaborate.3df2354655707ac5be53081aa5628663.svg";
export { ForwardRef as ReactComponent };